import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UserTiers = {
  NONE: '\u2014',
  PRO: 'Pro',
  BASIC: 'Basic',
} as const

export type UserTierEnum = Enum<typeof UserTiers>
